export default "__VITE_ASSET__B7_gtBzu__"